var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 78,
    viewBox: "0 0 76 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M75.313 20.6855C75.1041 20.1161 74.6774 19.653 74.1268 19.3982L32.6466 0.211606C31.5086 -0.314585 30.1596 0.173978 29.6224 1.30664L23.6689 13.8636H2.28514C1.02313 13.8636 0 14.8868 0 16.1488V75.7147C0 76.9767 1.02313 77.9998 2.28514 77.9998H47.976C48.8438 78.0046 49.676 77.505 50.0607 76.6769L75.2403 22.4344C75.4958 21.8843 75.5219 21.255 75.313 20.6855ZM45.7028 73.4296H4.57028V18.4339H45.7028V73.4296ZM50.273 65.3649V16.1488C50.273 14.8868 49.2499 13.8636 47.9879 13.8636H28.7269L32.7824 5.3099L70.1315 22.5855L50.273 65.3649Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 64.1367H34.2772C35.5392 64.1367 36.5623 63.1136 36.5623 61.8515C36.5623 60.5895 35.5392 59.5664 34.2772 59.5664H15.9961C14.7341 59.5664 13.7109 60.5895 13.7109 61.8515C13.7109 63.1136 14.7341 64.1367 15.9961 64.1367Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 54.9961H34.2772C35.5392 54.9961 36.5623 53.9729 36.5623 52.7109C36.5623 51.4489 35.5392 50.4258 34.2772 50.4258H15.9961C14.7341 50.4258 13.7109 51.4489 13.7109 52.7109C13.7109 53.9729 14.7341 54.9961 15.9961 54.9961Z",
    fill: "url(#paint2_linear)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 45.8554H34.2772C35.5392 45.8554 36.5623 44.8323 36.5623 43.5703C36.5623 42.3083 35.5392 41.2852 34.2772 41.2852H15.9961C14.7341 41.2852 13.7109 42.3083 13.7109 43.5703C13.7109 44.8323 14.7341 45.8554 15.9961 45.8554Z",
    fill: "url(#paint3_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9961 36.7148H20.5664C21.8284 36.7148 22.8516 35.6917 22.8516 34.4297C22.8516 33.1677 21.8284 32.1445 20.5664 32.1445H15.9961C14.7341 32.1445 13.7109 33.1677 13.7109 34.4297C13.7109 35.6917 14.7341 36.7148 15.9961 36.7148Z",
    fill: "url(#paint4_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 29.2737,
    y1: 197.124,
    x2: 641.601,
    y2: -231.612,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 22.5767,
    y1: 71.1166,
    x2: 42.1803,
    y2: 0.17012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 22.5767,
    y1: 61.976,
    x2: 42.1803,
    y2: -8.9705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 22.5767,
    y1: 52.8353,
    x2: 42.1803,
    y2: -18.1111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F79420"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 17.2573,
    y1: 43.6948,
    x2: 52.9678,
    y2: -8.00053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AE207C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.229167,
    stopColor: "#FF1C26"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.598958,
    stopColor: "#F79420"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyView);
export default __webpack_public_path__ + "static/media/emptyView.e546ca8ab0a0642be5525714d07330d9.svg";
export { ForwardRef as ReactComponent };